<template>
    <v-app>
        <v-container fluid fill-height class="ma-0 pa-0">
            <v-row class="fill-height" >
                <v-col class="pa-0 d-flex justify-center align-center">
                    <loading :message="$t('REDIRECTING')"/>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script lang="ts">
import Loading from '@/components/utils/Loading.vue'
import Vue from 'vue'
import Component from 'vue-class-component'
import { useAuthenticationStore } from '@/stores/authenticationStore';

@Component({
    components: { Loading }
})
export default class Redirect extends Vue {
    async created() {
        const redirectUrl = Array.isArray(this.$route.query['redirecturl'])
            ? this.$route.query['redirecturl'][0]
            : this.$route.query['redirecturl'];

        if (!redirectUrl) {
            this.$router.push('/');
            return;
        }

        const token = this.$route.query['s'];
        if (token) {
            await useAuthenticationStore().login({provider: 'sso', token });
        }

        window.location.assign(redirectUrl)
    }
}
</script>
